import { render } from "./Chapitre.vue?vue&type=template&id=23ca8c38&scoped=true"
import script from "./Chapitre.vue?vue&type=script&lang=js"
export * from "./Chapitre.vue?vue&type=script&lang=js"

import "./Chapitre.vue?vue&type=style&index=0&id=23ca8c38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ca8c38"]])

export default __exports__